import { LoaderIcon } from '@repo/go-ui';
import { RecommendationsTable as RecommendationsTableComponent } from '@repo/go-widgets';
import { observer } from 'mobx-react-lite';
import { Suspense, useEffect, useState, type ComponentProps, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { WIDGET_I18N_NAMESPACES } from 'src/app/i18n/widgetNamespaces';
import { useService } from 'src/packages/di';

import { RecommendationsStore } from './RecommendationsStore';

type Props = {
  tabsSwitcher?: ReactNode;
};

export const RecommendationsTable = observer(function RecommendationsTable({ tabsSwitcher }: Props) {
  const [store] = useState(() => new RecommendationsStore());
  const notifications = useService('notifications');
  const userPreferenceService = useService('userPreference');

  useEffect(() => {
    const disposer = store.init();
    return () => {
      disposer();
    };
  }, [store]);

  return (
    <Suspense fallback={<LoaderIcon />}>
      <RecommendationsTableContent
        service={store.recommendationsService}
        notifications={notifications}
        leftToolbarContent={tabsSwitcher}
        isAltNames={userPreferenceService.preferences.isAltNames}
      />
    </Suspense>
  );
});

type RecommendationsTableContentProps = Pick<
  ComponentProps<typeof RecommendationsTableComponent>,
  'service' | 'notifications' | 'leftToolbarContent' | 'isAltNames'
>;

const RecommendationsTableContent = observer(function RecommendationsTableContent(
  props: RecommendationsTableContentProps,
) {
  useTranslation(WIDGET_I18N_NAMESPACES.alertsRecommendations);

  return <RecommendationsTableComponent {...props} />;
});
